// extracted by mini-css-extract-plugin
export default {"accordionTitle":"styles_accordionTitle__8LKhG","toggler":"styles_toggler__DSTnu","contentBox":"styles_contentBox__M0arr","contentText":"styles_contentText__2najc"};